module.exports = __webpack_public_path__ + "img/crew_group.67f7f65a.jpg";